import React, { Fragment, useCallback, useReducer } from "react";
import { Button } from "@shopify/polaris";

import useToggle from "../../hooks/useToggle";

import { Trash } from "./actions/Trash";
import { reducerFn } from "../../helper";
import TiktokMarkAsOrderLabel from "./actions/tiktok-mark-as-order-label";
import MappingOrderUpdateQuantity from "./actions/update-quantity";

export const BulkActionMapping = ({ ids, onCompleted, filter }) => {
    // State
    const [open, toggleOpen] = useToggle(false);
    const [state, setState] = useReducer(reducerFn, {
        open: false,
        action: null,
    });

    const handleStateChange = useCallback(
        (action) => () => {
            setState({ open: true, action });
        },
        [],
    );

    const isTiktok = isTiktokFn(filter);

    const handleClose = useCallback(() => {
        setState({ open: false, action: null });
    }, []);

    const props = {
        open: state.open,
        onClose: handleClose,
        onCompleted,
        ids,
    };

    const actionMarkup = isTiktok
        ? {
              markOrderLabel: <TiktokMarkAsOrderLabel {...props} />,
          }
        : {
            updateQuantiy:   <MappingOrderUpdateQuantity {...props}  />,
        };

    const actionObj = actionMarkup[state.action] || null;

    return (
        <Fragment>
            <Button children="Trash" onClick={toggleOpen} />
            <Button children="Update Quantity" onClick={handleStateChange("updateQuantiy")} />
            {isTiktok ? (
                <Button
                    children="Mark Order Label"
                    onClick={handleStateChange("markOrderLabel")}
                />
            ) : null}
            <Trash
                open={open}
                onClose={toggleOpen}
                ids={ids}
                onCompleted={onCompleted}
            />

            {actionObj}
        </Fragment>
    );
};

function isTiktokFn(filter) {
    return filter?.type === "tiktok";
}
